<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="prepareReposiory"
                    :search-fields="prepareSearchFields"
                    label="Unidade"
                    v-model="model.unidadePrestadorId"
                    :text-field="i => i.nomeFantasia"
                    required
                    :validations="validations.unidadePrestadorId"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                @change="model.unidadePrestadorId = null, model.usuarioId = null, model.isProfissionalExecutante = false"
                                v-model="model.isPrestador"
                            >
                                Prestador
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="{
                        infraestrutura_id: model.unidadePrestadorId
                    }"
                    :searchFields="[{ key: 'cadastro_cidadao.nome', searchable: true }]"
                    label="Profissional executante"
                    :text-field="i => i.cidadaoNome"
                    v-model="model.usuarioId"
                    :disabled="!model.isProfissionalExecutante"
                    required
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                @change="model.usuarioId = null"
                                v-model="model.isProfissionalExecutante"
                                :disabled="!model.unidadePrestadorId || model.isPrestador"
                            >
                                Profissional executante
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

export default {
    computed: {
        prepareReposiory() {

            if (this.model.isPrestador) {

                return this.repositories.unidadeExecutanteManutencao.fornecedor
            } else {

                return this.repositories.unidadeExecutanteManutencao.unidade
            }
        },
        prepareSearchFields() {

            if (this.model.isPrestador) {

                return [
                    { key: 'fornecedor.nome_fantasia', searchable: true }
                ]
            } else {

                return [
                    { key: 'unidade.nome_fantasia', searchable: true }
                ]
            }
        },
        validations() {

            return {
                unidadePrestadorId: {
                    required: true
                },
            }
        },
    },
    created() {

        this.repositories = {
            unidadeExecutanteManutencao: this.getConectaSusRepository('cadastro.unidadeExecutanteManutencao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }

        this.load()
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.unidadeExecutanteManutencao.edit(this.id)
                    .then(({ data }) => {

                        if (data.model) {

                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.unidadeExecutanteManutencao.create()
                    .then(({ data }) => {

                        if (data.model) {

                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.unidadeExecutanteManutencao.update(this.id, this.prepareData())
                        : this.repositories.unidadeExecutanteManutencao.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.model);
        },
    },
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number },
    },
    watch: {
        'model.unidadePrestadorId'(newVal) {

            if (!newVal) {

                this.$set(this.model, 'isProfissionalExecutante', false);
                this.$set(this.model, 'usuarioId', null);
            }
        },
        'model.usuarioId'(newVal) {
            if (!newVal) {
                this.model.isProfissionalExecutante = false;
            }
        },
    }
}
</script>